'use client';

import Icon from '@/components/ui/AppIcon';


export default function SupportContactSection() {
  const contactMethods = [
  {
    id: 'contact_phone1',
    icon: 'PhoneIcon',
    title: 'Primary Phone',
    value: '0777 014 115',
    link: 'tel:0777014115',
    description: 'Call us during business hours'
  },
  {
    id: 'contact_phone2',
    icon: 'PhoneIcon',
    title: 'Secondary Phone',
    value: '0704 846 600',
    link: 'tel:0704846600',
    description: 'Alternative contact line'
  },
  {
    id: 'contact_email',
    icon: 'EnvelopeIcon',
    title: 'Email Support',
    value: 'info@bloomanimalfeeds.com',
    link: 'mailto:info@bloomanimalfeeds.com',
    description: 'Send us an email anytime'
  }];


  const businessHours = [
  { id: 'hours_weekday', day: 'Monday - Saturday', hours: '8:00 AM - 5:00 PM' },
  { id: 'hours_sunday', day: 'Sunday', hours: 'Closed' }];


  return (
    <section className="py-section px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 reveal">
          <p className="text-primary font-bold uppercase tracking-wider text-sm mb-4">Get In Touch</p>
          <h2 className="text-heading-2 md:text-[3rem] lg:text-heading-1 leading-tight text-foreground mb-6">
            Support <span className="gradient-text">Contact Options</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
            Our dedicated support team is here to assist you with any questions or concerns.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {contactMethods?.map((method, index) =>
          <a
            key={method?.id}
            href={method?.link}
            className="glass-card rounded-2xl p-8 hover:scale-105 transition-all reveal"
            style={{ animationDelay: `${index * 0.1}s` }}>
            
              <div className="w-16 h-16 rounded-2xl green-gradient flex items-center justify-center mb-6">
                <Icon name={method?.icon} size={32} className="text-white" />
              </div>
              <h3 className="text-heading-3 text-foreground mb-2">{method?.title}</h3>
              <p className="text-2xl font-bold text-primary mb-2">{method?.value}</p>
              <p className="text-sm text-muted-foreground">{method?.description}</p>
            </a>
          )}
        </div>

        <div className="glass-card rounded-2xl p-8 md:p-12 reveal">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-heading-3 text-foreground mb-6">Business Hours</h3>
              <div className="space-y-4">
                {businessHours?.map((schedule) =>
                <div key={schedule?.id} className="flex items-center justify-between py-4 border-b border-border last:border-0">
                    <div className="flex items-center gap-3">
                      <Icon name="ClockIcon" size={24} className="text-primary" />
                      <span className="text-lg font-semibold text-foreground">{schedule?.day}</span>
                    </div>
                    <span className="text-lg font-bold text-primary">{schedule?.hours}</span>
                  </div>
                )}
              </div>
              <div className="mt-8 p-4 bg-green-50 rounded-xl border border-primary/20">
                <div className="flex items-start gap-3">
                  <Icon name="InformationCircleIcon" size={24} className="text-primary flex-shrink-0 mt-0.5" />
                  <p className="text-sm text-foreground">
                    <strong>Note:</strong> Email inquiries are monitored 24/7 and will be responded to within 24 hours during business days.
                  </p>
                </div>
              </div>
            </div>

            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <div className="aspect-[4/3] bg-gradient-to-br from-green-100 to-green-50">
                <img
                  src="https://img.rocket.new/generatedImages/rocket_gen_img_1c8c0bf81-1764687936488.png"
                  alt="Layer hens in modern poultry farm with organized feeding systems"
                  className="w-full h-full object-cover" />
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}